import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';
import styles from './button.module.scss';

function Button({ children, onClick, href, regular, className, ...props }) {
  const cssClass = [styles.btn, ...className];
  if (regular) {
    cssClass.push(styles.regular);
  }
  if (href) {
    cssClass.push(styles.link);
    return (
      <Link className={cssClass.join(' ')} to={href}>
        {children}
      </Link>
    );
  }
  return (
    <button className={cssClass.join(' ')} type="button" onClick={onClick}>
      {children}
    </button>
  );
}

Button.defaultProps = {

};

Button.propTypes = {

};

export default Button;



// WEBPACK FOOTER //
// ./src/components/Button/index.jsx